interface SortableParticipant {
  isRegistered: boolean
  name: string
}

export function sortParticipants<T extends SortableParticipant>(a: T, b: T): number {
  if (a.isRegistered !== b.isRegistered) {
    return a.isRegistered ? -1 : 1
  }
  return a.name.localeCompare(b.name)
}
